module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "id": "anomalie-image",
      "src": _vm.anomalies.anomalie_image
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58ea9750!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/anomalies/AnomalieDownloadImage.vue
// module id = 1868
// module chunks = 2